<div style="position:relative" class="elfa-brand-swiper">
  <swiper-container #swiper init="false">
    <swiper-slide *ngFor="let brand of brands">
      <a *ngIf="brand.pictureUrl" [routerLink]="['/manufacturers', brand.seName]" routerLinkActive="router-link-active">
        <img [src]="brand.pictureUrl" [alt]="brand.name" class="brand-carousel-image">
      </a>
    </swiper-slide>
  </swiper-container>
</div>
